// ./src/lib/WSocket.js

import Sockette from 'sockette'; // https://github.com/lukeed/sockette

/**
 * reconnect timeout
 * onclose callback
 * onconnect callback
 * onerror callback
 * onmessage callback
 *
 * max_attempts ??
 * reconnect_timeout ??
 * socket_url !!
 */

const onMessage = Symbol('on-message');

class WSBus {
  constructor(url, opts = {}) {
    const defaultOptions = {
      timeout: 15e3,
      maxAttempts: 10,
    };

    this.options = { ...defaultOptions, ...opts };

    this.callbacks = [];
    this.url = url;

    this.retryTimeout = null;

    this.connectionPromise = this.initConnection();

    // this.connectionPromise = new Promise((resolve, reject) => {
    //   this.ws = new Sockette(url, {
    //     ...this.options,
    //     onopen: (e) => {
    //       console.log('Connected!', e);
    //       resolve(e);
    //     },
    //     onmessage: e => this[onMessage](e),
    //     onreconnect: e => console.log('Reconnecting...', e),
    //     onmaximum: (e) => {
    //       console.log('Stop Attempting!', e);

    //       this.retryTimeout = setTimeout(() => {
    //         if (!this.ws) return;

    //         console.log('Try to connect...');
    //         this.ws.open();
    //       }, 10e3);
    //     },
    //     onclose: e => console.log('Closed!', e),
    //     onerror: (e) => {
    //       console.log('Error:', e);
    //       this[onMessage]({ data: JSON.stringify({ event: 'connection_error' }) });
    //       reject(e);
    //     },
    //   });
    // });
  }

  async connectToGame({ game, code }) {
    return this.connectionPromise.then(() => {
      this.sendMessage({ event: 'attach', game_selector: game, attach_code: code });
    });
  }

  async reconnectToGame({ game, code }) {
    console.log('WSocket Reconnect');
    // this.connectionPromise = this.initConnection();
    // return this.connectToGame(data);
    this.initConnection()
      .then(() => {
        console.log('reconnect established');
        this.sendMessage({ event: 'attach', game_selector: game, attach_code: code });
      });
  }

  async initConnection() {
    console.log('WSocket -> init connection');
    return new Promise((resolve, reject) => {
      this.ws = new Sockette(this.url, {
        ...this.options,
        onopen: (e) => {
          console.log('Connected!', e);
          resolve(e);
        },
        onmessage: e => this[onMessage](e),
        onreconnect: e => console.log('Reconnecting...', e),
        onmaximum: (e) => {
          console.log('Stop Attempting!', e);

          this.retryTimeout = setTimeout(() => {
            if (!this.ws) return;

            console.log('Try to connect...');
            this.ws.open();
          }, 10e3);
        },
        onclose: e => console.log('Closed!', e),
        onerror: (e) => {
          console.log('Error:', e);
          this[onMessage]({ data: JSON.stringify({ event: 'connection_error' }) });
          reject(e);
        },
      });
    });
  }

  onEvent(callback) {
    this.callbacks.push(callback);
  }

  [onMessage](e) {
    const data = JSON.parse(e.data);
    this.callbacks.forEach(cb => cb(data));
  }

  sendMessage(payload) {
    if (!this.ws) throw new Error('socket closed');

    console.log('Send message -> ', payload);

    this.ws.json(payload);
  }

  close() {
    if (this.ws) {
      this.ws = this.ws.close();
    }
  }

  reconnect() {
    this.ws.reconnect();
  }
}

export default WSBus;
